import MyPageMobileContainer from './MyPageMobileContainer';
export default MyPageMobileContainer;
